import { Button as UIButton, type ButtonProps } from "../ui/button";

type Props = Omit<ButtonProps, "variant"> & {
  /** 예전 이름을 그대로 받는다 — 화면 열여섯 곳을 한꺼번에 고치지 않으려고. */
  variant?: "primary" | "ghost" | "outline" | "destructive" | "danger";
};

/**
 * 버튼 원자. 이제 shadcn 계열 UIButton 을 감싼다.
 *
 * 예전 이름(primary·ghost)을 받아 새 변형으로 옮긴다. 화면을 하나씩 새 이름으로 옮기는
 * 동안에도 둘 다 동작해야 한다 — 한 번에 다 고치면 무엇이 깨졌는지 못 가린다.
 */
export default function Button({ variant = "primary", ...rest }: Props) {
  const mapped = variant === "primary" ? "default" : variant;
  return <UIButton variant={mapped} {...rest} />;
}
